import { useLocation, useNavigate } from "react-router-dom";
import { CATEGORY_OPTIONS } from "../constants/categories";

export default function Navbar({
  searchQuery = "",
  onSearchChange,
  categoryFilter = "",
  onCategoryChange,
  showCategoryFilter = false,
  showSearch = false,
}) {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { label: "Home", path: "/products" },
    { label: "Profile", path: "/profile" },
    { label: "My Orders", path: "/orders" },
    { label: "Cart", path: "/cart" },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <div
      className={`wf-nav${showCategoryFilter ? " wf-nav--with-category" : ""}`}
    >
      <button type="button" className="wf-brand" onClick={() => navigate("/")}>
        <img
          src="/favicon-48-white.png"
          alt="Balitah logo"
          className="wf-brand-logo"
        />
        BALITAH
      </button>

      {showSearch ? (
        <input
          className="wf-search"
          placeholder="Search products"
          value={searchQuery}
          onChange={(e) => onSearchChange?.(e.target.value)}
        />
      ) : (
        <div></div>
      )}

      {showCategoryFilter ? (
        <select
          className="wf-category-select"
          value={categoryFilter}
          onChange={(e) => onCategoryChange?.(e.target.value)}
        >
          <option value="">All Categories</option>
          {CATEGORY_OPTIONS.map((category) => (
            <option key={category} value={category}>
              {category}
            </option>
          ))}
        </select>
      ) : null}

      <div className="wf-nav-actions">
        {navItems.map((item) => (
          <button
            key={item.path}
            className={`wf-btn${isActive(item.path) ? " wf-btn--active" : ""}`}
            onClick={() => navigate(item.path)}
          >
            {item.label}
          </button>
        ))}
      </div>
    </div>
  );
}
